import React from "react";
import { TextToolTip } from "../textToolTip";
import { Svg } from "assets";

export const EditActionBtn = ({ onClick }) => {
  return (
    <TextToolTip
      placement="left"
      arrow
      wrapperStyles={{
        width: "fit-content",
        height: "fit-content",
      }}
      classNameText="table-single-action-wrapper"
      showTooltip
      content="edit"
      onClick={(e) => {
        e?.stopPropagation();
        e?.preventDefault();
        onClick(e);
      }}
      text={<Svg.EditInfoSvg className="table-single-action-edit-svg" />}
    />
  );
};
